export default "__VITE_ASSET__Dl2TidHd__"